export const checkCircleIcon = `
<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24"
     fill="none">
  <path
    d="M12.75 2C7.23 2 2.75 6.48 2.75 12C2.75 17.52 7.23 22 12.75 22C18.27 22 22.75 17.52 22.75 12C22.75 6.48 18.27 2 12.75 2ZM10.75 17L5.75 12L7.16 10.59L10.75 14.17L18.34 6.58L19.75 8L10.75 17Z"
    fill="var(--zbp-svg-primary-color, black)"
  />
</svg>
`;
